var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bpc-field-wrapper',_vm._b({},'bpc-field-wrapper',_vm.fieldWrapperAttributes,false),[_c('b-button',{attrs:{"href":_vm.loginUrl,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t('accounting_integrations.exact.auth_button'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }